import React, { useEffect } from 'react';
import { Box, Grid } from '@mui/material';

import { StepperEnum, useWizardStepperContext } from '../../../../contexts/useWizardStepper.context';
import WizardPivotParentColumnComponent from './wizard-pivot-parent-column/wizard-pivot-parent-column.component';
import useWizardReportDataContext from '../../../../contexts/useWizardReportData.context';
import WizardPivotParentFunctionComponent from './wizard-pivot-parent-function/wizard-pivot-parent-function.component';
import WizardPivotChildColumns from './wizard-pivot-child-columns/wizard-pivot-child-columns.component';


/**
 * @author Pradeep R <pradeep.rajendran@rldatix.com>
 * @createdOn Jan/05/2025
 */
export default function WizardReportPivotingComponent({ }: {}) {

    const { activeStep, activeStepIndex, validateStep } = useWizardStepperContext();
    const { pivotData } = useWizardReportDataContext();

    useEffect(() => {
        if (activeStep === StepperEnum.Pivot) {

            const isValid = (!pivotData || !pivotData.parentColumn) || !!(
                pivotData.parentColumn &&
                pivotData.parentGroupByFunction &&
                pivotData.childColumns?.every(
                    (x) => x.childColumnName !== null && x.childColumnGroupByValue !== null
                )
            );

            // validate
            validateStep(activeStepIndex, isValid)
        }
    }, [pivotData])


    return (<Box hidden={activeStep !== StepperEnum.Pivot} sx={{ px: 4, pt: 1, pb: 1 }}>

        {/* AgGrid */}
        <Grid item container direction="column" wrap="nowrap" sx={{ p: 0, }}>

            {/* Parent Pivot Column */}
            <Grid container direction={'row'} sx={{ pt: 5, px: 2, pb: 1 }} gap={2}>
                <Grid item xs>
                    <WizardPivotParentColumnComponent />
                </Grid>
                <Grid item xs>
                    {pivotData?.parentColumn && <WizardPivotParentFunctionComponent />}
                </Grid>
            </Grid>

            {/* Child Column Grid */}
            {pivotData?.parentGroupByFunction && <WizardPivotChildColumns />}

        </Grid>

    </Box>)
}